import { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  Button,
  IconButton,
  Box,
  Typography,
  DialogTitle,
  useTheme,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { AxiosService } from "../../services/axios/axiosService";
import toast from "react-hot-toast";

const RescheduleInterviewDialog = ({
  open,
  onClose,
  candidateData,
  onRescheduleSuccess,
}) => {
  const theme = useTheme();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSend = async () => {
    setLoading(true);
    try {
      const payload = {
        Application_ID: candidateData?.applicationId?.toString() || "",
        Candidate_ID: candidateData?.zohoCandidateId?.toString() || "",
        Candidate_Name: candidateData?.candidateName || "",
        JobOpeningID: candidateData?.zohoJobOpeningId?.toString() || "",
        PostingTitle: candidateData?.jobTitle || "",
        Email: candidateData?.candidateEmail || "",
      };

      await AxiosService.post(`/api/Interview`, payload);

      toast.success("Interview rescheduled successfully!");

      if (typeof onRescheduleSuccess === "function") {
        await onRescheduleSuccess();
      }

      onClose();
    } catch (err) {
      toast.error(err.message || "Failed to reschedule interview");
      setError(err.message || "Failed to reschedule interview");
      //onClose();
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
  }, [candidateData, open]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          backgroundColor: theme.palette.background.paper,
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          pb: 2,
          borderBottom: `1px solid ${theme.palette.divider}`,
        }}
      >
        <Typography
          variant="h6"
          sx={{ fontWeight: 600, color: theme.palette.text.primary }}
        >
          Reschedule IGNA Scout Interview
        </Typography>
        <IconButton
          onClick={onClose}
          size="small"
          sx={{ color: theme.palette.text.secondary }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ pt: 2, pb: 2 }}>
        <Box
          sx={{
            my: 2,
            px: 2,
            py: 1,
            borderRadius: 2,
            backgroundColor:
              theme.palette.mode === "dark"
                ? "rgba(255, 255, 255, 0.05)"
                : "#fafafa",
            border: `1px solid ${theme.palette.divider}`,
            display: "flex",
            justifyContent: "space-between",
            gap: 2,
            alignItems: "center",
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Typography
              variant="body2"
              mb={0.5}
              sx={{
                color: theme.palette.text.secondary,
                fontWeight: 500,
              }}
            >
              Candidate Name
            </Typography>
            <Typography
              variant="body2"
             
              sx={{
                fontWeight: 500,
                color: theme.palette.text.primary,
                textTransform: "capitalize",
              }}
            >
              {candidateData?.candidateName || "-"}
            </Typography>
          </Box>

          <Box sx={{ flex: 1,}}>
            <Typography
              variant="body2"
              mb={0.5}
              sx={{
                color: theme.palette.text.secondary,
                fontWeight: 500,
              }}
            >
              Job Title
            </Typography>

            <Typography
              variant="body2"
              sx={{
               
                fontWeight: 500,
                color: theme.palette.text.primary,
              }}
            >
              {candidateData?.jobTitle || "-"}
            </Typography>
          </Box>
        </Box>

        <Box sx={{ textAlign: "center" }}>
          <Typography variant="h6" p={2}>
            Are you sure you want to reschedule ?
          </Typography>
        </Box>

        {/* {error && ( 
          <Box sx={{ display: "flex", justifyContent: "center",  pt: 2 }}>
            <Typography variant="body1" color="error">{error}</Typography>
          </Box>
        )} */}
        <Divider fullWidth />  
        <Box sx={{ display: "flex", justifyContent: "center", gap: 2, pt: 2 }}>
          <Button variant="outlined" color="secondary" onClick={onClose} disabled={loading}>
           No
          </Button>
          <Button variant="contained" onClick={handleSend} disabled={loading}>
            {loading ? "Rescheduling..." : "Yes"}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default RescheduleInterviewDialog;
